import { useState, useEffect } from 'react';


const Statistics = () => {

  return (
    <div style={{ height: 750 }} className='bodyJ'>
      <h1 style={{ fontFamily: 'Lucida Console', color: "darkblue", paddingTop: 30 }} >Some Stats about us:</h1>
      <h2 style={{ textAlign: 'center', paddingLeft: 30, fontFamily: 'Lucida Console', color: "lightgreen", paddingTop: 30 }} >Funny Jokes shared: 20,000</h2>
      <h2 style={{ textAlign: 'center', paddingLeft: 30, fontFamily: 'Lucida Console', color: "lightgreen", paddingTop: 30 }} >Times Syd has stolen the blanket: 800</h2>
      <h2 style={{ textAlign: 'center', paddingLeft: 30, fontFamily: 'Lucida Console', color: "lightgreen", paddingTop: 30 }} >Times at Applebees: 30</h2>
      <h2 style={{ textAlign: 'center', paddingLeft: 30, fontFamily: 'Lucida Console', color: "lightgreen", paddingTop: 30 }} >Times Logan has done a little dance for syd: 500</h2>
      <h2 style={{ textAlign: 'center', paddingLeft: 30, fontFamily: 'Lucida Console', color: "lightgreen", paddingTop: 30 }} >Times Syd has accidentally drooled on Logan: 4.25 Million</h2>
      <h2 style={{ textAlign: 'center', paddingLeft: 30, fontFamily: 'Lucida Console', color: "lightgreen", paddingTop: 30 }} >Times Logan has said: 'Gnarly', 'Karma's a bitch...', 'Eat Zucchini...' or '67...': 400 billion</h2>
      <h2 style={{ textAlign: 'center', paddingLeft: 30, fontFamily: 'Lucida Console', color: "lightgreen", paddingTop: 30 }} >Times Syd has said it's cold and it's ~75 degrees : 40</h2>
      <h2 style={{ textAlign: 'center', paddingLeft: 30, fontFamily: 'Lucida Console', color: "lightgreen", paddingTop: 30 }} >Pounds of ketchup Logan has consumed: 900</h2>
    </div >


  );
}

export default Statistics;